<script>
  import options from './ProjectsList.options'
  export default options
</script>

 <template>

     <section class="kb-projects-list"> 

        <template v-if="results ? results?.length : false">

          <div v-if="!hideTotalCount" class="kb-projects-list__meta-top-container" aria-live="polite" :class="{'kb-projects-list__meta-top-container--hide': hideTotalCount}">
            <p class="kb-projects-list__results-number">
              <span>
                {{ totalCount }}
              </span>
              {{ getLabel('resultTypeTitle') }}
            </p>
          </div>

        </template>

        <SearchFilteredTags v-if="tags ?? tags.length > 0" :guids="[guid]" />

        <template v-if="!resultCount && !showSpinner && !hideNoResults">
          <div class="kb-projects-list__no-results">
            <h2>{{ getLabel('noResultTitle') }}</h2>
            <p class="kb-projects-list__no-results-summary">{{ getLabel('noResultDesc') }}</p>
            <a :href="getLabel('noResultButtonHref')" class="kb-button kb-button--full-color-spot">{{
              getLabel('noResultButtonText') }}</a>
          </div>
        </template>


        <ul class="kb-projects-list__results kb-projects-list__results--grid-4col" >
          <template v-for="(result, index) in results" :key="index">
            <template v-if="result.isSpotCard">
              <li>
                <SpotCardGrid :spotCardData="result" />
              </li>
            </template>
            <template v-else>
              <li>
                <ProjectCard :result="result" />
              </li>
            </template>
          </template>
        </ul>

        <div class="kb-projects-list__more-results">
          <span v-if="resultCount" class="kb-projects-list__more-results__text">  {{ getLabel('resultOutForTitle', [resultCount, totalCount]) }} </span>
          <template v-if="canShowMore">
            <button @click="getMoreResults" class="kb-button kb-button--full-color">
              {{ getLabel('showMoreButtonText') }}
            </button>
          </template>
        </div>

        <div v-if="showSpinner" class="kb-spinner-overlay">
          <div class="kb-spinner-overlay__spinner">
          </div>
        </div>

        </section>

 </template>
 

